import { Schema } from "@markdoc/markdoc";

export const element: Schema = {
  selfClosing: true,
  render: "Element",
  attributes: {
    label: {
      type: String,
      required: true,
    },
    href: {
      type: String,
    },
  },
};
